import { FunctionComponent, ReactNode } from "react";
import { FieldError } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { classNames } from "primereact/utils";

import "./FormField.scss";

export interface IFormFieldRules {
  required?: boolean;
}

interface IFormFieldProps {
  fieldNameTranslationKey: string;
  fieldDescriptionTranslationKey?: string;
  fieldName: string;
  hideLabel?: boolean;
  invalid: boolean;
  error?: FieldError;
  children: ReactNode;
}

export const FormField: FunctionComponent<IFormFieldProps> = (props: IFormFieldProps) => {
  const { t } = useTranslation();

  return (
    <div className="form-field">
      <div
        className={classNames("form-field-header", {
          hiddenLabel: props.hideLabel,
        })}
      >
        {!props.hideLabel && (
          <label
            htmlFor={props.fieldName}
            className={classNames("form-field-header-label", {
              invalid: props.invalid,
            })}
          >
            {t(props.fieldNameTranslationKey)}

            {!!props.fieldDescriptionTranslationKey && (
              <small className="description">({t(props.fieldDescriptionTranslationKey)})</small>
            )}
          </label>
        )}

        {!!props.invalid && <small className="error-message">{props.error?.message}</small>}
      </div>

      {props.children}
    </div>
  );
};
